/**
 * Debugging Utility for Styled Console Logs
 * Provides consistent and styled logs for debugging purposes.
 */

const isDebugMode = false; // Toggle this to enable/disable debug logs globally

/**
 * Styled console log
 * @param {string} label - Label for the log
 * @param {any} data - Data to log
 * @param {string} color - Color for the label (default: blue)
 */
export const debugLog = (label, data, color = 'blue') => {
  if (!isDebugMode) return;

  const styles = [
    `color: white; background-color: ${color}; padding: 2px 4px; border-radius: 3px;`,
    'color: black; background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px;',
  ];

  console.log(`%c${label}%c`, styles[0], styles[1], data);
};

/**
 * Styled console warning
 * @param {string} label - Label for the warning
 * @param {any} data - Data to log
 */
export const debugWarn = (label, data) => {
  if (!isDebugMode) return;

  const styles = [
    'color: white; background-color: orange; padding: 2px 4px; border-radius: 3px;',
    'color: black; background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px;',
  ];

  console.warn(`%c${label}%c`, styles[0], styles[1], data);
};

/**
 * Styled console error
 * @param {string} label - Label for the error
 * @param {any} data - Data to log
 */
export const debugError = (label, data) => {
  if (!isDebugMode) return;

  const styles = [
    'color: white; background-color: red; padding: 2px 4px; border-radius: 3px;',
    'color: black; background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px;',
  ];

  console.error(`%c${label}%c`, styles[0], styles[1], data);
};

export function debugProps(componentName, props) {
  console.group(`${componentName} Props`);
  for (const key in props) {
    console.log(`${key}:`, props[key]);
  }
  console.groupEnd();
}
